import type { ClientsListRestoreIntent } from '@/entities/clients-filter.entity';

type FeedRow = { clientId: string; id?: string | number };

export function resolveClientsListRestoreIndex(intent: ClientsListRestoreIntent, items: readonly unknown[]): number | null {
	if (intent.listType === 'clients') {
		const idx = (items as readonly { id: string }[]).findIndex(c => c.id === intent.clientId);
		return idx >= 0 ? idx : null;
	}

	const rows = items as readonly FeedRow[];

	if (intent.itemId !== undefined) {
		const idx = rows.findIndex(row => row.id === intent.itemId);
		if (idx >= 0) return idx;
	}

	const byClient = rows.findIndex(row => row.clientId === intent.clientId);
	return byClient >= 0 ? byClient : null;
}
